import { styled } from "@styles";
import { Button, Col } from "react-bootstrap";

export const Wrapper = styled.div``;

export const FaqTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 3rem;
`;
export const FaqButton = styled(Button)`
  width: 100%;
  padding: 1.5rem 2.5rem;
  background-color: #F2F3F5;
  border-color: #F2F3F5;
  color: black;
  text-align: left;
  display: flex;
  justify-content: space-between;
  &:hover {
    border-color: #FF3399;
    color: #FF3399;
    background-color: #F2F3F5;
    text-decoration: none;
  }
`;

export const LiveChatText = styled.p`
  text-align: center;
`;